export const PRECEDING = "PRECEDING";
export const MODIFIED_PRECEDING = "MODIFIED_PRECEDING";
export const FOLLOWING = "FOLLOWING";
export const MODIFIED_FOLLOWING = "MODIFIED_FOLLOWING";

export default {
  PRECEDING,
  MODIFIED_PRECEDING,
  FOLLOWING,
  MODIFIED_FOLLOWING
};

